import "../../assets/css/views/absences/absencesMassive.css";
import { useTranslation } from "react-i18next";
import {
  Button,
  FilePicker,
  Group,
  IconHelp,
  Modal,
} from "@veneer/core";
import Loader from "../../components/Loader/loader";
import LoaderModal from "../../components/Loader/loaderModal";
import { useAbsencesMassive } from "../../hooks/absences/useAbsencesMassive";
import SimpleMessageModalWithOpenClose from "../../components/Modals/SimpleMessageModalWithOpenClose";

export default function AbsencesMassive() {
  const [t] = useTranslation("global");
  const {
    handleCreateAbsences,
    setOpenModalHelp,
    openModalHelp,
    loading,
    handleDownloadTemplate,
    loadingModal,
    openModalCreate,
    handleOnClickExit,
    buttonSaveDisabled,
    fileName,
    errorFilePicker,
    messageError,
    handleFileChange,
    submitAbsences,
    onClearFilePicker,
    openModalCreateDone,
    openModalError,
    setOpenModalCreateDone,
    setOpenModalError,
  } = useAbsencesMassive();

  return (
    <div className="absences-massive-container">
      {loading && <Loader />}
      <h4 className="absences-massive-title">
        {t("header.absencesMassiveTitle")}
      </h4>

      <div className="absences-massive-buttons">
        <div>
          <Button onClick={handleCreateAbsences} style={{ margin: "5px" }}>
            {t("header.uploadFile")}
          </Button>

          <div className="tooltip">
            <span className="tooltiptext">
              {t("modal.titleHelper").replace(":", "?")}
            </span>
            <Button
              style={{ margin: "5px" }}
              appearance="secondary"
              leadingIcon={<IconHelp />}
              onClick={() => setOpenModalHelp(true)}
            ></Button>
          </div>
        </div>

        <div className="absences-massive-buttons-right">
          <Button
            onClick={handleDownloadTemplate}
            style={{ margin: "5px" }}
          >
            {t("header.downloadTemplate")}
          </Button>
        </div>
      </div>

      <SimpleMessageModalWithOpenClose
        setOpenCloseModal={setOpenModalHelp}
        showModal={openModalHelp}
        modalTitle={t("modal.titleHelper")}
        modalMessage={t("modal.helperAbsencesMassive")}
      />

      {loadingModal && <LoaderModal />}

      <div style={{ position: "relative" }}>
        <Modal
          align="center"
          closeButton
          id="modal-Create"
          show={openModalCreate}
          onClose={handleOnClickExit}
          footer={
            <div className="buttonGroup">
              <Group>
                <Button appearance="secondary" onClick={handleOnClickExit}>
                  {t("header.closebutton")}
                </Button>
                <Button onClick={submitAbsences} disabled={buttonSaveDisabled}>
                  {t("header.sendButton")}
                </Button>
              </Group>
            </div>
          }
          title={t("header.absencesMassiveTitle")}
        >
          <div>
            <h5>{t("header.uploadFile")}</h5>
            <FilePicker
              className="modalSellOutFile"
              id="absences-file-picker"
              label={t("header.uploadFile")}
              accept=".xlsx"
              onChange={handleFileChange}
              onClear={onClearFilePicker}
              value={fileName}
              error={errorFilePicker}
              helperText={messageError}
            />
          </div>
        </Modal>
      </div>

      <SimpleMessageModalWithOpenClose
        showModal={openModalCreateDone}
        setOpenCloseModal={setOpenModalCreateDone}
        modalTitle={t("modal.message")}
        modalMessage={t("modal.messageAbsences")}
      />

      <SimpleMessageModalWithOpenClose
        showModal={openModalError}
        setOpenCloseModal={setOpenModalError}
        modalTitle={t("header.error")}
        modalMessage={t("modal.generalError")}
      />
    </div>
  );
}
